import Swiper from "swiper";
import {
  Autoplay,
  Navigation,
  Pagination,
  Thumbs,
  EffectCreative,
  EffectFade,
  Parallax,
  Scrollbar,
  Mousewheel,
  
} from "swiper/modules";
// import { register } from 'swiper/element/bundle'

Swiper.use([
  Autoplay,
  Thumbs,
  Navigation,
  Pagination,
  EffectCreative,
  EffectFade,
  Parallax,
  Scrollbar,
  Mousewheel
]);
// @ts-expect-error types
window.Swiper = Swiper;

function init() {
  // register()

}

export default { init };
